import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Label,
  Input,
  Button,
  Form,
  FormGroup,
  Spinner,
} from "reactstrap";
import Select from "react-select";
import { ToastContainer } from 'react-toastify';
import { toast } from 'react-toastify';

import { api } from "../../config";
import { fetchComAuth, fetchComAuthJson } from '../../common/api';

const camposExpositorConfig = [
  { key: "exibirLogo", label: "Logo" },
  { key: "exibirNome", label: "Nome" },
  { key: "exibirDescricao", label: "Descrição" },
  { key: "exibirDescricaoProdutosServicos", label: "Descrição produtos e serviços" },
  { key: "exibirSetores", label: "Setores" },
  { key: "exibirAreasInteresse", label: "Áreas de interesse" },
  { key: "exibirCategorias", label: "Categorias" },
  { key: "exibirDadosContato", label: "Dados de contato" },
  { key: "exibirEndereco", label: "Endereço" },
  { key: "exibirImagens", label: "Imagens" },
];

const TelaConfiguracaoRota = ({ feiraId, editando }) => {
  const [config, setConfig] = useState({
    id: null,
    cor_principal: "#43c2cb",
    cor_secundaria: "#364574",
    cor_estande_padrao: "#43c2cb",
    cor_estande_destacado: "#e2ec1dff",
    cor_traco_rota: "#10c340ff",
    cor_label: "#e3e5ebff",
    cor_contorno_estandes: "#363637ff",
    cor_plano_fundo: "#ffffffff",
    tem_banner_destaque: false,
    qtd_expositores_destaque: 4,
    expositores_destaque: [],
    campos_exibidos: {}, // Inicia vazio, será populado
    qtd_max_imagens: 6,
    qtd_max_videos: 3,
    local_banner: 1,
    mapa_centralizado: false,
    abrir_caminho_rota_texto: true,
  });

  const [expositoresOpcoes, setExpositoresOpcoes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const carregarDados = async () => {
      if (!feiraId || !editando) return;
      setIsLoading(true);
      try {
        const resConfig = await fetchComAuthJson(`${api.API_URL}/configuracao-rota/${feiraId}`);
        const configData = await resConfig.json();
        
        const resExpositores = await fetchComAuth(`${api.API_URL}/feiraExpositor/${feiraId}`);
        const expositoresData = await resExpositores.json();
        const opcoesExpositores = expositoresData.data.map(e => ({ value: e.id, label: e.nome }));
        
        setExpositoresOpcoes(opcoesExpositores);

        const dadosSalvos = configData.data;

        if (dadosSalvos) {
          const rota = dadosSalvos.rota[0];
          
          const config = dadosSalvos.configuracao[0];
          const expositoresDestaqueSalvos = dadosSalvos.expositores_destaque;
          const idsExpositoresDestaque = expositoresDestaqueSalvos.map(exp => exp.expositor_id);
          const expositoresDestaqueFormatados = opcoesExpositores.filter(opt => 
              idsExpositoresDestaque.includes(opt.value)
          );
          let camposExibidosObjeto = {};
          try {
            camposExibidosObjeto = JSON.parse(rota.configuracao_expositor);
          } catch (e) {
            camposExibidosObjeto = {};
          }

          setConfig({
            id: rota ? rota.id : null,
            cor_principal: config.cor_principal || "#43c2cb",
            cor_secundaria: config.cor_secundaria || "#364574",
            tem_banner_destaque: rota ? rota.tem_banner_destaque : false,
            qtd_expositores_destaque: rota ? rota.quantidade_expositores_destaque || 4 : 4,
            qtd_max_imagens: rota ? rota.quantidade_imagem || 6 : 6,
            qtd_max_videos: rota ? rota.quantidade_video || 3 : 3,
            expositores_destaque: expositoresDestaqueFormatados,
            campos_exibidos: camposExibidosObjeto,
            cor_estande_destacado: rota ? rota.cor_estande_destacado || "#e2ec1dff" : "#e2ec1dff",
            cor_estande_padrao: rota ? rota.cor_estande_padrao || "#43c2cb" : "#43c2cb",
            cor_traco_rota: rota ? rota.cor_traco_rota || "#10c340ff" : "#10c340ff",
            cor_label: rota ? rota.cor_label || "#e3e5ebff" : "#e3e5ebff",
            local_banner: rota ? rota.local_banner || 1  : 1,
            mapa_centralizado: rota ? rota.mapa_centralizado : false,
            abrir_caminho_rota_texto: rota ? rota.abrir_caminho_rota_texto : true,
            cor_contorno_estandes: rota ? rota.cor_contorno_estandes || "#363637ff" : "#363637ff",
            cor_plano_fundo: rota ? rota.cor_plano_fundo || "#ffffffff" : "#ffffffff",
          });
        }
      } catch (err) {
        console.error("Erro ao carregar dados da configuração de rota:", err);
        toast.error("Falha ao carregar configurações.");
      } finally {
        setIsLoading(false);
      }
  };

  useEffect(() => {
    carregarDados();
  }, [feiraId, editando]);

  const handleConfigChange = (e) => {
    const { name, value, type, checked } = e.target;
    let valor = type === 'checkbox' ? checked : value;

    if (name === "local_banner") {
      valor = parseInt(value, 10);
    }

    if (name.startsWith("exibir")) {
      setConfig(prev => ({
        ...prev,
        campos_exibidos: {
          ...prev.campos_exibidos,
          [name]: valor,
        }
      }));
    } else {
      setConfig(prev => ({ ...prev, [name]: valor }));
    }
  };

  const handleSalvar = async () => {
    if (config.tem_banner_destaque) {
      const numSelecionados = config.expositores_destaque.length;
      const numMax = parseInt(config.qtd_expositores_destaque, 10);
      
      // Valida se o número máximo é um número válido e positivo, e se o número de selecionados excede o máximo
      if (isNaN(numMax) || numMax <= 0 || numSelecionados > numMax) {
        toast.error(`A quantidade de expositores em destaque selecionados (${numSelecionados}) não pode exceder a quantidade máxima definida (${numMax > 0 ? numMax : '0'}).`);
        return; // Impede o salvamento
      }
      
       // Opcional: Avisa se o número de selecionados for menor que o máximo
       if (numSelecionados < numMax) {
        toast.warn(`Você selecionou ${numSelecionados} expositores, mas o máximo configurado é ${numMax}.`);
        // Não impede o salvamento, apenas avisa
       }
    }
    
    const payload = {
      id: config.id, // Envia o ID para o backend saber que é um PUT
      feira_id: feiraId,
      cor_principal: config.cor_principal,
      cor_secundaria: config.cor_secundaria,
      tem_banner_destaque: config.tem_banner_destaque,
      // Mapeia os nomes do estado de volta para os nomes da API
      quantidade_expositores_destaque: config.qtd_expositores_destaque,
      quantidade_imagem: config.qtd_max_imagens,
      quantidade_video: config.qtd_max_videos,
      // Transforma o objeto de volta para uma string JSON para salvar no banco
      configuracao_expositor: JSON.stringify(config.campos_exibidos),
      // Mapeia o valor do Select de volta para um array de IDs
      expositores_destaque: config.expositores_destaque.map(e => e.value),
      cor_estande_destacado: config.cor_estande_destacado,
      cor_estande_padrao: config.cor_estande_padrao,
      cor_label: config.cor_label,
      cor_traco_rota: config.cor_traco_rota,
      local_banner: config.local_banner,
      mapa_centralizado: config.mapa_centralizado,
      abrir_caminho_rota_texto: config.abrir_caminho_rota_texto,
      cor_contorno_estandes: config.cor_contorno_estandes,
      cor_plano_fundo: config.cor_plano_fundo
    };
   
    const method = config.id ? 'PUT' : 'POST';
    const url = `${api.API_URL}/configuracao-rota`;

    try {
      const response = await fetchComAuthJson(url, {
        method: method,
        body: JSON.stringify(payload)
      });
      // Verifica se a requisição foi bem-sucedida
      if (!response.ok) throw new Error("Erro na resposta da API");
      
      toast.success("Configurações salvas com sucesso!");
      carregarDados();
    } catch (err) {
      console.error("Erro ao salvar configuração:", err);
      toast.error("Erro ao salvar as configurações.");
    }
  };

  if (isLoading) {
    return <Spinner />;
  }
  
  return (
    <Row>
      <ToastContainer closeButton={false} />
      {/* Cores */}
      <Col lg={12}>
        <Card>
          <CardHeader><h5 className="card-title mb-0">Cores</h5></CardHeader>
          <CardBody>
            <Row>
              <Col lg={2}>
                <FormGroup>
                  <Label htmlFor="cor_principal" className="form-label">Cor Principal</Label>
                  <Input type="color" className="form-control form-control-color w-100" name="cor_principal" value={config.cor_principal} onChange={handleConfigChange} />
                </FormGroup>
              </Col>
              <Col lg={2}>
                <FormGroup>
                  <Label htmlFor="cor_secundaria" className="form-label">Cor Secundária</Label>
                  <Input type="color" className="form-control form-control-color w-100" name="cor_secundaria" value={config.cor_secundaria} onChange={handleConfigChange} />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col lg={2}>
                <FormGroup>
                  <Label htmlFor="cor_estande_destacado" className="form-label">Espaço Destaque</Label>
                  <Input type="color" className="form-control form-control-color w-100" name="cor_estande_destacado" value={config.cor_estande_destacado} onChange={handleConfigChange} />
                </FormGroup>
              </Col>
              <Col lg={2}>
                <FormGroup>
                  <Label htmlFor="cor_estande_padrao" className="form-label">Espaço Padrão</Label>
                  <Input type="color" className="form-control form-control-color w-100" name="cor_estande_padrao" value={config.cor_estande_padrao} onChange={handleConfigChange} />
                </FormGroup>
              </Col>
              <Col lg={2}>
                <FormGroup>
                  <Label htmlFor="cor_label" className="form-label">Texto no Espaço</Label>
                  <Input type="color" className="form-control form-control-color w-100" name="cor_label" value={config.cor_label} onChange={handleConfigChange} />
                </FormGroup>
              </Col>
              <Col lg={2}>
                <FormGroup>
                  <Label htmlFor="cor_traco_rota" className="form-label"> Traço rota</Label>
                  <Input type="color" className="form-control form-control-color w-100" name="cor_traco_rota" value={config.cor_traco_rota} onChange={handleConfigChange} />
                </FormGroup>
              </Col>
              <Col lg={2}>
                <FormGroup>
                  <Label htmlFor="cor_contorno_estandes" className="form-label">Cor contorno estandes</Label>
                  <Input type="color" className="form-control form-control-color w-100" name="cor_contorno_estandes" value={config.cor_contorno_estandes} onChange={handleConfigChange} />
                </FormGroup>
              </Col>
              <Col lg={2}>
                <FormGroup>
                  <Label htmlFor="cor_plano_fundo" className="form-label"> Cor plano de fundo mapa</Label>
                  <Input type="color" className="form-control form-control-color w-100" name="cor_plano_fundo" value={config.cor_plano_fundo} onChange={handleConfigChange} />
                </FormGroup>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Col>
      
      <Col lg={12}>
        <Card>
          <CardHeader><h5 className="card-title mb-0">Mapa e Rotas</h5></CardHeader>
          <CardBody>
            <Row>
              <Col lg={6}>
                <FormGroup switch className="mb-3">
                  <Input type="switch" name="mapa_centralizado" checked={config.mapa_centralizado} onChange={handleConfigChange} />
                  <Label check>Mapa ser exibido centralizado na tela de rotas</Label>
                </FormGroup>
              </Col>
              
              <Col lg={6}>
                <FormGroup switch className="mb-3">
                  <Input type="switch" name="abrir_caminho_rota_texto" checked={config.abrir_caminho_rota_texto} onChange={handleConfigChange} />
                  <Label check>Exibir o texto com o caminho da rota (origem e destino)</Label>
                </FormGroup>
              </Col>

            </Row>
          </CardBody>
        </Card>
      </Col>

      {/* Destaques dos Expositores */}
      <Col lg={12}>
        <Card>
          <CardHeader><h5 className="card-title mb-0">Destaques dos Expositores</h5></CardHeader>
          <CardBody>
            <Form>
              
              <FormGroup switch className="mb-3">
                <Input type="switch" name="tem_banner_destaque" checked={config.tem_banner_destaque} onChange={handleConfigChange} />
                <Label check>Habilitar banner de expositores em destaque</Label>
              </FormGroup>

              {config.tem_banner_destaque && (
              
              <Row className="g-3">
                  <Col lg={3} md={6}>
                    <Label className="form-label" htmlFor="local_banner">Local do Banner</Label>
                    <select
                      id="local_banner" 
                      name="local_banner" // Nome deve ser igual à chave no estado 'config'
                      className="form-select"
                      value={config.local_banner || 1} // Vincula ao estado config
                      onChange={handleConfigChange}    // Usa a função genérica que você já tem
                    >
                      <option value="1">Topo</option>
                      <option value="2">Rodapé</option>
                    </select>
                  </Col>
              
                  <Col lg={3} md={6}>
                    <FormGroup>
                      <Label htmlFor="qtd_expositores_destaque">Quantidade de expositores</Label>
                      <Input id="qtd_expositores_destaque" name="qtd_expositores_destaque" type="number" min={1} value={config.qtd_expositores_destaque} onChange={handleConfigChange} />
                    </FormGroup>
                  </Col>
                  <Col lg={9} md={6}>
                    <FormGroup>
                      <Label htmlFor="expositores_destaque">Expositores em destaque</Label>
                      <Select
                        isMulti
                        options={expositoresOpcoes}
                        value={config.expositores_destaque}
                        onChange={selectedOptions => setConfig(prev => ({ ...prev, expositores_destaque: selectedOptions || [] }))}
                        placeholder="Selecione os expositores..."
                        styles={{
                          multiValueLabel: (styles) => ({
                            ...styles,
                            color: 'white', // Cor do texto do label
                            fontWeight: 'bold',         // Outras opções de estilo
                          }),
                          multiValue: (styles) => ({
                            ...styles,
                            backgroundColor: '#1a73e8', // Cor do chip como um todo (opcional)
                          }),
                        }}
                      />
                    </FormGroup>
                  </Col>
                </Row>
              )}
            </Form>
          </CardBody>
        </Card>
      </Col>

      {/* Campos do Expositor */}
      <Col lg={12}>
        <Card>
          <CardHeader><h5 className="card-title mb-0">Campos exibidos no Expositor</h5></CardHeader>
          <CardBody>
            <Row className="g-3">
              {camposExpositorConfig.map((campo) => (
                <Col key={campo.key} lg={6}>
                  <FormGroup switch>
                    <Input type="switch" name={campo.key} checked={!!config.campos_exibidos[campo.key]} onChange={handleConfigChange} />
                    <Label check>{campo.label}</Label>
                  </FormGroup>
                </Col>
              ))}
            </Row>
            <hr />
            <Row>
              <Col lg={6}>
                <FormGroup>
                  <Label htmlFor="qtd_max_imagens">Quantidade máx. de imagens</Label>
                  <Input id="qtd_max_imagens" name="qtd_max_imagens" type="number" min={0} value={config.qtd_max_imagens} onChange={handleConfigChange} />
                </FormGroup>
              </Col>
              {/* <Col lg={6}>
                <FormGroup>
                  <Label htmlFor="qtd_max_videos">Quantidade máx. de vídeos</Label>
                  <Input id="qtd_max_videos" name="qtd_max_videos" type="number" min={0} value={config.qtd_max_videos} onChange={handleConfigChange} />
                </FormGroup>
              </Col> */}
            </Row>
          </CardBody>
        </Card>
      </Col>

      {/* Ações */}
      <Col lg={12} className="d-flex justify-content-end gap-2 mb-3">
        <Button color="success" onClick={handleSalvar}>Salvar</Button>
      </Col>
    </Row>
  );
}

export default TelaConfiguracaoRota;